<template>
  <div class="container">
    <!-- 커뮤니티 시설 안내 (Community Facilities Section) -->
    <section class="community-section">
      <div class="community-container">
        <h2 class="section-title">
          <span class="highlight-text">2030세대 맞춤형</span> 편의 커뮤니티 시설 안내
        </h2>
        <p class="community-subtitle">
          맞춤 커뮤니티 시설을 제공하는 <strong class="highlight-text">2030세대의 라이프스타일</strong>에 최적화된 환경입니다.
        </p>
        <div class="community-grid">
          <!-- 시설 카드 -->
          <div class="facility-card">
            <div class="facility-image-container" @click="openPopup('coin')">
              <img src="/image/coin-room.webp" alt="코인세탁소" class="facility-image" />
              <div class="hover-overlay">이미지를 누르시면 상세한 내부 사진을 볼 수 있습니다.</div>
            </div>
            <div class="facility-info">
              <h3 class="facility-title">코인세탁실</h3>
              <p class="facility-subtitle">바쁜 일상을 지원하는 셀프 세탁 공간</p>
            </div>
          </div>

          <div class="facility-card">
            <div class="facility-image-container" @click="openPopup('book')">
              <img src="/image/book-room.webp" alt="북카페" class="facility-image" />
              <div class="hover-overlay">이미지를 누르시면 상세한 내부 사진을 볼 수 있습니다.</div>
            </div>
            <div class="facility-info">
              <h3 class="facility-title">북카페</h3>
              <p class="facility-subtitle">입주민 전용의 여유로운 시간과 휴식을 제공</p>
            </div>
          </div>
        </div>
      </div>
    </section>

      <!-- 자식 팝업 갤러리 컴포넌트 -->
      <image-gallery :floorType="currentFloorType" :isPopupOpen="isPopupOpen" @close="closePopup" />
  </div>
</template>

<script>
import ImageGallery from "@/components/CommunityGallery.vue";

export default {
  components: { ImageGallery },
  data() {
      return {
          currentFloorType: null,
          isPopupOpen: false
      };
  },
  methods: {
      openPopup(floorType) {
          this.currentFloorType = floorType;
          this.isPopupOpen = true;
      },
      closePopup() {
          this.isPopupOpen = false;
      }
  }
}
</script>

<style scoped>
.container {
  background-color: #f5f7fa;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* 커뮤니티 섹션 스타일 */
.community-section {
  padding: 80px 0;
  text-align: center;
  max-width: 1200px;
  width: 100%; /* ✅ 전체 너비로 확장 */
  margin: 0 auto;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #333;
  line-height: 1.3;
}

.community-subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
}

.highlight-text {
  color: #69c3ff;
  font-weight: 700;
}

/* 시설 카드 스타일 */
.community-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* ✅ 카드가 가로로 꽉 차도록 */
  gap: 20px; /* ✅ 카드 사이의 간격 */
  width: 100%;
  max-width: 1200px; /* ✅ 1200px 너비에 맞춤 */
  margin: 0 auto;
}

.facility-card {
  flex: 1 1 calc(33.333% - 20px); /* ✅ 3개 카드가 1200px에 맞춤 */
  max-width: 600px; /* ✅ 최대 너비로 카드 폭 제한 */
  min-width: 300px; /* ✅ 최소 너비 설정 (반응형 대응) */
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.facility-card:hover {
  transform: translateY(-5px);
}

.facility-image-container {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
}

.facility-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}

.facility-card:hover .facility-image {
  opacity: 0.8;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.facility-card:hover .hover-overlay {
  opacity: 1;
}

.facility-info {
  padding: 16px;
}

.facility-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
}

.facility-subtitle {
  font-size: 0.95rem;
  color: #666;
}

/* ✅ 반응형 설정 */
@media (max-width: 768px) {
  .facility-card {
    flex: 1 1 calc(48% - 20px); /* ✅ 두 개로 정렬 */
  }
}

@media (max-width: 480px) {
  .facility-card {
    flex: 1 1 100%; /* ✅ 한 개로 정렬 */
  }
}
</style>
